// Shared look and small helpers for the office SAFed lifecycle panels (Session BDB).
import { ApiError } from "../../../../lib/api";

export const inputCls = "w-full rounded-ele border border-ele-purple-accent bg-ele-field px-3 py-2 outline-none focus:border-ele-green";
export const btnCls = "min-h-11 rounded-ele border border-ele-green px-3 font-menu text-xs uppercase tracking-wide text-ele-green disabled:opacity-40";
export const quietBtnCls = "min-h-11 px-3 text-sm text-ele-muted";
export const cardCls = "rounded-ele border border-ele-purple-accent bg-ele-surface p-3";

export function errorText(err: unknown, fallback: string): string {
  if (err instanceof ApiError && err.body && typeof (err.body as { message?: unknown }).message === "string") return (err.body as { message: string }).message;
  return fallback;
}

export function poundsFromPence(pence: number): string {
  const fixed = (Math.abs(pence) / 100).toFixed(2);
  const [whole, frac] = fixed.split(".");
  return `£${whole!.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${frac}`;
}
